const removeQueryParams = () => {
  const searchParams = new URLSearchParams(window.location.search);

  searchParams.delete("nombre-sucursal");
  searchParams.delete("id-sucursal");

  const newRelativePathQuery = window.location.pathname + searchParams.toString();
  history.pushState(null, "", newRelativePathQuery);
};

export default removeQueryParams;
